import Badge from "../../assets/images/all-driver-reviews/moved-badge.svg"
import {
  CompletedShipmentStat,
  CompletedShipmentsContext,
} from "@/components/CompletedShipmentStat"
import Image from "next/image"
import { FC, useContext } from "react"
import classNames from "classnames"
import { readImage } from "../../app/utils/read-image"
import { BlokImage } from "../../storyblok"
import PageNav, { NavigationType } from "../../storyblok/sections/PageNav"
import { PremiumHeroForm } from "../premium/hero-form"

export interface IPremiumHero {
  blok: {
    tagline: string
    title: string
    description: string
    buttonLink?: string
    buttonLabel?: string
    bgImage?: BlokImage
    bgSmImage?: BlokImage
    navItems?: NavigationType["navItems"]
    categories?: NavigationType["categories"]
    isNavHidden?: boolean
    ctaRoute?: string
    hasNavigation?: boolean
    showBadge?: boolean
  }
}
const PremiumHero: FC<IPremiumHero> = (props) => {
  const { concept: shipmentConcept } = useContext(CompletedShipmentsContext)
  const {
    tagline,
    title,
    description,
    buttonLabel,
    buttonLink,
    bgSmImage,
    bgImage,
    ctaRoute,
    navItems = [],
    categories = [],
    isNavHidden,
    hasNavigation,
    showBadge = false,
  } = props.blok

  return (
    <>
      {hasNavigation && (
        <PageNav
          noBlok
          route={ctaRoute || buttonLink}
          buttonLabel={buttonLabel}
          navigationData={{ navItems, categories, isNavHidden }}
          position=""
        />
      )}
      <section
        id="premium-hero"
        className={classNames("relative md:h-[685px]")}
      >
        <div className="absolute h-[385px] inset-0 z-1 md:h-[78%]">
          {bgImage && (
            <Image
              className="hidden md:block"
              src={readImage(bgImage)}
              alt={bgImage.alt || "hero image"}
              layout="fill"
              objectFit="cover"
              objectPosition="top"
            />
          )}
          {bgSmImage && (
            <Image
              className="md:hidden"
              src={readImage(bgSmImage ?? bgImage)}
              alt={bgSmImage.alt || "hero image"}
              layout="fill"
              objectFit="cover"
              objectPosition="center"
            />
          )}
          {showBadge &&
            (shipmentConcept ? (
              <CompletedShipmentStat className="w-40 md:w-48 absolute right-4 bottom-4 md:bottom-auto md:top-10 md:right-10 z-10 rounded-xl bg-white text-blue-900 p-3 text-center text-xs md:text-sm shadow-md" />
            ) : (
              <Image
                className="w-[92px] h-[92px] sm:w-[100px] sm:h-[100px] md:w-[120px] md:h-[120px] absolute right-4 bottom-4 md:bottom-0 md:top-10 md:right-10 z-10"
                src={Badge}
                alt={"100k pets transported"}
                width={120}
                height={120}
              />
            ))}
        </div>

        <div className="absolute h-[385px] inset-0 bg-black bg-opacity-50 md:h-[78%] "></div>

        <div className="h-[385px] md:h-[78%] relative max-w-4xl lg:max-w-5xl xl:max-w-7xl mx-auto px-6 lg:px-8 py-8 ">
          <div className="text-white font-merriweather max-w-3xl text-left">
            <p className="text-md font-light italic md:mt-10 lg:mt-20 mb-0">
              {tagline}
            </p>
            <h1 className="text-[26px] leading-[50px] sm:text-[42px] sm:leading-[72px] md:text-[56px] font-bold lg:text-[56px] mt-1 md:mt-4 mb-6">
              {title}
            </h1>
            <p
              id="PremiumHero-description"
              className="text-lg max-w-lg font-inter"
            >
              {description}
            </p>
          </div>
        </div>
        <div className="relative rounded lg:absolute lg:bottom-5 max-w-7xl mx-auto md:flex justify-center bg-white rounded-1 md:h-[200px] px-6 md:px-5 lg:px-10 py-11 right-0 left-0">
          <PremiumHeroForm buttonLabel={buttonLabel} buttonLink={buttonLink} />
        </div>
      </section>
      <section className="lg:mb-5" />
    </>
  )
}

export default PremiumHero
